<div class="menu-container">

    <div class="menu-header">
        <div class="back-arrow">

            <button mat-icon-button *ngIf="isInSelection()" class="dotted-arrow" (click)="back()">
                ←
            </button>
            <button mat-icon-button *ngIf="!isInSelection()" class="dotted-arrow" (click)="onCloseSiteMenu()">
                ←
            </button>
        </div>

        <h3 i18n="@@product-sorted-search_field-advanced-search" class="headline">Advanced Search</h3>
    </div>

    <div class="menu" [formGroup]="form">
        <div class="menu-items-wrapper">
            <div *ngIf="!isInSelection()" class="search">
                <form class="searchbar" (submit)="submitSearch()">
                    <div fxLayout fxLayoutAlign="flex-start" class="searchbar">
                        <button class="submitButton">
                            <mat-icon class="search-icon" svgIcon="hering-search"></mat-icon>
                        </button>

                        <input formControlName="advanced" type="text" placeholder="Search..."/>
                    </div>
                </form>
            </div>

            <div mat-list-item *ngIf="!isInSelection()" (click)="openSubmenu('decor')" class="menu-item"
                 i18n="@@product-sorted-search_field-decor">
                Decor
            </div>
            <div class="select-wrapper" *ngIf="decorTypeOpen">
                <mat-selection-list formControlName="decor">
                    <mat-list-option *ngFor="let attributeOption of decors" [value]="attributeOption">
                        {{attributeOption.label}}
                    </mat-list-option>
                </mat-selection-list>
            </div>


            <div mat-list-item *ngIf="!isInSelection()" (click)="openSubmenu('occasion')" class="menu-item"
                 i18n="@@product-sorted-search_field-occasion">
                Occasion
            </div>
            <div class="select-wrapper" *ngIf="(occasionTypeOpen)">
                <mat-selection-list formControlName="occasion">
                    <mat-list-option *ngFor="let attributeOption of occasions" [value]="attributeOption">
                        {{attributeOption.label}}
                    </mat-list-option>
                </mat-selection-list>
            </div>


            <div mat-list-item *ngIf="!isInSelection()" (click)="openSubmenu('productType')" class="menu-item"
                 i18n="@@product-sorted-search_field-product-type">
                Shape
            </div>
            <div class="select-wrapper" *ngIf="(productTypeOpen)">
                <mat-selection-list formControlName="productType">
                    <mat-list-option *ngFor="let attributeOption of productTypes" [value]="attributeOption">
                        {{attributeOption.label}}
                    </mat-list-option>
                </mat-selection-list>
            </div>

            <div mat-list-item *ngIf="!isInSelection()" (click)="openSubmenu('purpose')" class="menu-item"
                 i18n="@@product-sorted-search_field-purpose">
                Purpose
            </div>
            <div class="select-wrapper" *ngIf="purposeTypeOpen">
                <mat-selection-list formControlName="purpose">
                    <mat-list-option *ngFor="let attributeOption of purpose" [value]="attributeOption">
                        {{attributeOption.label}}
                    </mat-list-option>
                </mat-selection-list>
            </div>

            <div mat-list-item *ngIf="!isInSelection()" (click)="openSubmenu('productCategory')" class="menu-item"
                 i18n="@@product-sorted-search_field-product-category">
                Inspiration
            </div>
            <div class="select-wrapper" *ngIf="productCategoryTypeOpen">
                <mat-selection-list formControlName="productCategory">
                    <mat-list-option *ngFor="let attributeOption of productCategory" [value]="attributeOption">
                        {{attributeOption.label}}
                    </mat-list-option>
                </mat-selection-list>
            </div>

            <div mat-list-item *ngIf="!isInSelection()" (click)="openSubmenu('color')" class="menu-item"
                 i18n="@@product-sorted-search_field-product-color">
                Color
            </div>
            <div class="select-wrapper" *ngIf="colorTypeOpen">
                <mat-selection-list formControlName="color">
                    <mat-list-option *ngFor="let attributeOption of color" [value]="attributeOption">
                        {{attributeOption.label}}
                    </mat-list-option>
                </mat-selection-list>
            </div>

            <div mat-list-item *ngIf="!isInSelection()" (click)="openSubmenu('sort')" class="menu-item"
                 i18n="@@product-sorted-search_field-sort">
                Sort
            </div>
            <div class="select-wrapper sort-wrapper" *ngIf="(sortTypeOpen)">
                <mat-selection-list formControlName="sort" [multiple]="false">
                    <mat-list-option *ngFor="let attributeOption of sortOptions" [value]="attributeOption">
                        <!--This is the weirdest way to add a translation in a for loop but somehow it works...-->
                        <div i18n="@@mobile-product-sorted-search_sort-options">{ attributeOption.label, select, sortOption, {sortOption}}</div>
                        <div class="sorting-pseudo-checkbox"></div>
                    </mat-list-option>
                </mat-selection-list>
            </div>
        </div>
    </div>

    <div class="footer">
        <button class="btn-primary main-btn" (click)="resetDropdowns()">Reset</button>
        <button i18n="@@product-sorted-search_save" *ngIf="isInSelection()" class="btn-primary main-btn" (click)="back()">Save</button>
        <button i18n="@@product-sorted-search_show-results" *ngIf="!isInSelection()" class="btn-primary main-btn" (click)="submitSearch()">Show Results</button>
    </div>
</div>
